"use client";

import { createContext, useContext, type ReactNode } from "react";

import type { BlogSourceEntry } from "@/utils/blog";

const SourcesContext = createContext<BlogSourceEntry[] | null>(null);

export function SourcesProvider({
  sources,
  children,
}: Readonly<{
  sources: BlogSourceEntry[] | undefined;
  children: ReactNode;
}>) {
  return (
    <SourcesContext.Provider value={sources ?? []}>
      {children}
    </SourcesContext.Provider>
  );
}

export function useBlogSources(): BlogSourceEntry[] {
  return useContext(SourcesContext) ?? [];
}
